import { useForm } from "react-hook-form";
import { useCallback, useState } from "react";
import useUserForm from "$hooks/useUserForm";
import { EntrepotService } from "$services";
import useAuth from "$hooks/useAuth";
import { Warehouse } from "$types";

export type FormValues = Warehouse;

export const useEntrepotFormLogic = (
  entrepot?: any,
  parentCompanyId?: string
) => {
  const [matchingWarehouses, setMatchingWarehouses] = useState([]);
  const { token } = useAuth();

  const defaultValues: FormValues = entrepot
    ? {
        activities: (entrepot.activities || []).map((ac: any) => ac),
        companies: entrepot.companies || [],
        createdBy: entrepot.createdBy,
        delivery: {
          am: entrepot.delivery?.am || [],
          pm: entrepot.delivery?.pm || [],
        },
        isManageable: entrepot.isManageable,
        location: {
          adress: entrepot.location?.adress,
          city: entrepot.location?.city,
          complement: entrepot.location?.complement,
          country: entrepot.location?.country,
          cp: entrepot.location?.cp,
        },
        notes: entrepot.notes,
        name: entrepot.name,
        medias: entrepot.medias,
        parentCompany: entrepot.parentCompany,
        users: entrepot.users,
      }
    : {
        delivery: {
          am: [],
          pm: [],
        },
        activities: [],
        companies: [],
        createdBy: null,
        isManageable: true,
        notes: "",
        name: "",
        medias: [],
        location: {
          adress: "",
          city: "",
          complement: "",
          cp: "",
          country: "France",
        },
        parentCompany: parentCompanyId,
        users: [],
      };

  const form = useForm({
    mode: "onChange",
    defaultValues,
  });

  const currentParentCompany = form.watch(
    "parentCompany",
    defaultValues.parentCompany
  );
  const currentWarehouse = form.watch("name", defaultValues.name);

  const {
    onAddClick,
    onSubmit: onUserSubmit,
    onSubmitEdit: onUserSubmitEdit,
    setTitle,
    open: openUser,
    togglePopin: toggleUserPopin,
    error: errorUser,
  } = useUserForm(currentParentCompany);

  const handleUserAddClick = () => {
    onAddClick();
    setTitle("Ajouter un contact");
  };

  const handleUserPopinSubmit = async (data: any) => {
    if (data.id) {
      await onUserSubmitEdit(data);
    } else {
      await onUserSubmit(data);
    }
  };

  const fuzzySearchOnWarehouseName = useCallback(
    async (input: string) => {
      try {
        if (!input) {
          setMatchingWarehouses([]);
          return;
        }
        const warehouses = await EntrepotService.getEntrepotsByName(
          token,
          input
        );
        setMatchingWarehouses(warehouses);
      } catch (error) {
        console.error(error);
        setMatchingWarehouses([]);
      }
    },
    [token]
  );

  return {
    form,
    currentParentCompany,
    currentWarehouse,
    handleUserAddClick,
    handleUserPopinSubmit,
    // user form
    onAddClick,
    openUser,
    toggleUserPopin,
    onUserSubmit,
    onUserSubmitEdit,
    errorUser,
    setTitle,
    matchingWarehouses,
    fuzzySearchOnWarehouseName,
  };
};
